module.exports = __webpack_public_path__ + "img/SceneCloudH52.71cd0126.png";